export default __webpack_public_path__ + "static/media/8.25975594.png";